import React from 'react';
import { TextField, Button } from '@mui/material';
import authenticationService from '../../../services/auth.service';
import authenticationHelperService from '../../../services/auth-helper.service';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import routeService from '../../../routes/route.service';
import { customTheme } from '../../../styles/theme';

const useStyles = makeStyles({
  paper: {
    marginTop: customTheme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: customTheme.spacing(3),
    backgroundColor: 'transparent',
    height: '10vh',
  },
  title: {
    textAlign: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: customTheme.spacing(1),
  },
  submit: {
    margin: customTheme.spacing(3, 0, 2),
  },
});

export default function LoginComponent() {
  const navigate = useNavigate();

  const [submitData, setSubmitData] = React.useState({
    email: '',
    password: '',
  });

  React.useEffect(() => {
    if (authenticationHelperService.isAuthenticated()) {
      navigate(routeService.getUserWatchlistPath());
    }
  }, []);

  const submitDataChangeHandler = (event: any) => {
    const { name, value, type, checked } = event.target;
    setSubmitData({
      ...submitData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const login = (event: any) => {
    authenticationService.login(submitData.email, submitData.password).then(isSuccess => {
      if (isSuccess) {
        navigate(routeService.getUserWatchlistPath());
      }
    });

    event.preventDefault();
  };

  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img alt="logo" className={classes.avatar} src="/images/icons/icon-192x192.png" />
        <div>
          <Typography component="h1" variant="h5" className={classes.title}>
            Sign in
          </Typography>
          <form className={classes.form} onSubmit={login}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              type="email"
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              defaultValue=""
              onChange={submitDataChangeHandler}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={submitDataChangeHandler}
            />
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
              Login
            </Button>
          </form>
        </div>
      </div>
    </Container>
  );
}
